import { isCancel as m, AxiosError as h } from "axios";
import { AccessDenied as p } from "./index4.mjs";
import { BadRequest as u, BadRequestWithViolations as R } from "./index5.mjs";
import { ConflictError as E } from "./index6.mjs";
import { FailedDependency as l } from "./index9.mjs";
import { InternalError as g } from "./index10.mjs";
import { invalidTokenErrorMessages as k } from "./index11.mjs";
import { LockedError as T } from "./index12.mjs";
import { MaintenanceError as y } from "./index13.mjs";
import { NetworkError as q } from "./index14.mjs";
import { NotFound as i } from "./index15.mjs";
import { PayloadTooLarge as F } from "./index16.mjs";
import { UnauthorizedResponse as N } from "./index17.mjs";
import { UnprocessableContentError as A } from "./index18.mjs";
const K = (a, n) => {
  let o = !1, r = [];
  const c = () => a.post("/api/user/token/regenerate"), w = (t) => {
    r.push(t);
  }, f = () => {
    r.forEach((t) => t()), r = [];
  }, d = async (t) => {
    const e = t.config;
    if (!o) {
      o = !0;
      try {
        return await c(), o = !1, f(), await a(e);
      } catch (s) {
        throw o = !1, r = [], s;
      }
    }
    return new Promise((s) => {
      w(() => {
        s(a(e));
      });
    });
  };
  return async (t) => {
    if (m(t))
      throw t;
    if (t = t, t.code === h.ERR_NETWORK)
      throw new q();
    const e = t.response;
    if (!e)
      throw t;
    switch (e.status) {
      case 400:
        throw "errors" in e.data ? new u(e.data) : new R(e.data);
      case 401:
        if (k.includes(e.data.message))
          return await d(t);
        if (e.data.location)
          throw new N(e.data.location);
        n == null || n.error("Unauthorized response", e.data);
        break;
      case 403:
        throw new p();
      case 404:
        throw new i(i.isNotFoundResponse(e.data) ? e.data : void 0);
      case 409:
        throw new E(e.data);
      case 413:
        throw new F();
      case 422:
        throw new A(e.data);
      case 423:
        throw new T();
      case 424:
        throw new l(e.data.title);
      case 503:
        throw new y();
      case 500:
      case 502:
        throw new g();
    }
    throw t;
  };
};
export {
  K as getErrorMapper
};
